module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0076.jpg?v=e9629e5a";